import { defineTypes } from '../_utils'

const types = {
  SET_MENU_ORDER: 'SET_MENU_ORDER',
  SET_SUB_MENU_ORDER: 'SET_SUB_MENU_ORDER',
  SET_SUB_MENU_ACTIVE: 'SET_SUB_MENU_ACTIVE',
  RESET_MENU: 'RESET_MENU',
  SET_MENU: 'SET_MENU'
}

defineTypes(types, 'WORKBENCH')

export default types
